import {useQuery} from "@tanstack/react-query";
import bosService from "../../../../services/web/bos-service.js";
import projectUtils from "../../../../utils/project-utils.js";
import teamService from "../../../../services/web/team-service.js";
import dispatchListOptionsService from "../../../../services/dispatch/dispatch-list-options-service.js";
import {garrisonTimelineKeys} from "../utils/garrison-timeline-utils.js";
import DispatchListOptionsService from "../../../../services/dispatch/dispatch-list-options-service.js";

const UseGarrisonTimelineQueries = () => {
  const {data: leaders, isLoading: isLoadingLeaders} = useQuery({
    queryFn: bosService.getLeaders,
    select: data => projectUtils.formatToSelect(data),
    queryKey: garrisonTimelineKeys.leaders()
  })

  const {data: teams, isLoading: isLoadingTeams} = useQuery({
    queryFn: teamService.getAllTeams,
    queryKey: garrisonTimelineKeys.teams()
  })

  const {data: contingent, isLoading: isLoadingContingent} = useQuery({
    queryFn: () => DispatchListOptionsService.contingents(),
    queryKey: garrisonTimelineKeys.contingent()
  })

  const isLoading = isLoadingLeaders || isLoadingTeams || isLoadingContingent;

  return({
    leaders,
    teams,
    contingent,
    isLoading
  })
}

export default UseGarrisonTimelineQueries;
